import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  accessAuthorities: [],
  authorityDeviceSummary: {
    total: 0,
    hardwares: [],
  },
  authorityEmployeeSummary: {
    total: 0,
    employees: [],
  },
  authorityDeviceMember: {
    total: 0,
    hardwares: [],
  },
  authorityEmployeeMember: {
    total: 0,
    employees: [],
  },
}

export const mutations = {
  SET_ACCESS_AUTHORITIES(state, accessAuthorities) {
    state.accessAuthorities = accessAuthorities
  },
  SET_AUTHORITY_DEVICE_SUMMARY(state, authorityDeviceSummary) {
    state.authorityDeviceSummary = authorityDeviceSummary
  },
  SET_AUTHORITY_EMPLOYEE_SUMMARY(state, authorityEmployeeSummary) {
    state.authorityEmployeeSummary = authorityEmployeeSummary
  },
  SET_AUTHORITY_DEVICE_MEMBER(state, authorityDeviceMember) {
    state.authorityDeviceMember = authorityDeviceMember
  },
  SET_AUTHORITY_EMPLOYEE_MEMBER(state, authorityEmployeeMember) {
    state.authorityEmployeeMember = authorityEmployeeMember
  },
  ADD_ACCESS_AUTHORITY(state, accessAuthority) {
    state.accessAuthorities.push(accessAuthority)
  },
  DELETE_ACCESS_AUTHORITY(state, authority_uuid) {
    const index = state.accessAuthorities.findIndex(
      (item) => item.authority_uuid === authority_uuid
    )
    if (index !== -1) state.accessAuthorities.splice(index, 1)
  },
  EDIT_ACCESS_AUTHORITY(state, accessAuthority) {
    const index = state.accessAuthorities.findIndex(
      (item) => item.authority_uuid === accessAuthority.authority_uuid
    )
    if (index !== -1) {
      state.accessAuthorities.splice(index, 1, accessAuthority)
    }
  },
}

export const actions = {
  fetchAccessAuthorities({ commit }, payload) {
    return ApiService.fetchAccessAuthorities(payload)
      .then((res) => {
        const accessAuthorities = res.data.data
        commit('SET_ACCESS_AUTHORITIES', accessAuthorities)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchAccessAuthority({ commit }, payload) {
    return ApiService.fetchAccessAuthority(payload)
      .then((res) => {
        const accessAuthority = res.data
        return accessAuthority
      })
      .catch((error) => {
        throw error
      })
  },
  addAccessAuthority({ commit }, payload) {
    return ApiService.addAccessAuthority(payload)
      .then((res) => {
        const accessAuthority = res.data
        commit('ADD_ACCESS_AUTHORITY', accessAuthority)
        return accessAuthority
      })
      .catch((error) => {
        throw error
      })
  },
  deleteAccessAuthority({ commit }, payload) {
    return ApiService.deleteAccessAuthority(payload)
      .then(() => {
        commit('DELETE_ACCESS_AUTHORITY', payload.authority_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  editAccessAuthority({ commit }, payload) {
    return ApiService.editAccessAuthority(payload)
      .then((res) => {
        const accessAuthority = res.data
        commit('EDIT_ACCESS_AUTHORITY', accessAuthority)
        return accessAuthority
      })
      .catch((error) => {
        throw error
      })
  },
  fetchAuthorityDeviceSummary({ commit }, payload) {
    return ApiService.fetchAuthorityDeviceSummary(payload)
      .then((res) => {
        const authorityDeviceSummary = res.data
        commit('SET_AUTHORITY_DEVICE_SUMMARY', authorityDeviceSummary)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchAuthorityEmployeeSummary({ commit }, payload) {
    return ApiService.fetchAuthorityEmployeeSummary(payload)
      .then((res) => {
        const authorityEmployeeSummary = res.data
        commit('SET_AUTHORITY_EMPLOYEE_SUMMARY', authorityEmployeeSummary)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchAuthorityDeviceMember({ commit }, payload) {
    return ApiService.fetchAuthorityDeviceMember(payload)
      .then((res) => {
        const authorityDeviceMember = res.data
        commit('SET_AUTHORITY_DEVICE_MEMBER', authorityDeviceMember)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchAuthorityEmployeeMember({ commit }, payload) {
    return ApiService.fetchAuthorityEmployeeMember(payload)
      .then((res) => {
        const authorityEmployeeMember = res.data
        commit('SET_AUTHORITY_EMPLOYEE_MEMBER', authorityEmployeeMember)
      })
      .catch((error) => {
        throw error
      })
  },
  addAuthorityDeviceMember({ commit }, payload) {
    return ApiService.addAuthorityDeviceMember(payload).catch((error) => {
      throw error
    })
  },
  addAuthorityEmployeeMember({ commit }, payload) {
    return ApiService.addAuthorityEmployeeMember(payload).catch((error) => {
      throw error
    })
  },
  deleteAuthorityDeviceMember({ commit }, payload) {
    return ApiService.deleteAuthorityDeviceMember(payload).catch((error) => {
      throw error
    })
  },
  deleteAuthorityEmployeeMember({ commit }, payload) {
    return ApiService.deleteAuthorityEmployeeMember(payload).catch((error) => {
      throw error
    })
  },
}
